import React, { useEffect, useState, useRef } from 'react';
import UserService from '../services/UserService';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { Row, Col, OverlayTrigger, Tooltip, Form, Button } from 'react-bootstrap';
import StickyMenu from '../components/common/StickyMenu';
import Footer from './shared/Footer';
import Navbar from './shared/Navbar';
import Sidebar from './shared/Sidebar';
import { Circles } from 'react-loader-spinner';
import SettingsPanel from './shared/SettingsPanel';
import Switch from "react-switch";
import adminServices from '../services/adminServices';
import swal from 'sweetalert';
import ReactSelect from 'react-select';
import { CustomEditor } from '../components/CustomEditor';
import './adminConfiguration.css';
import { Editor } from '@tinymce/tinymce-react';
import { htmlToText } from 'html-to-text';


const languages = [

    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },

    {
        code: 'hi',
        name: 'Hindi',
        country_code: 'in'
    }
]

const AdminConfiguration = () => {

    const currentLanguageCode = Cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
    const { t } = useTranslation()

    useEffect(() => {
        document.body.dir = currentLanguage.dir || 'ltr'
        document.title = t('app_title')
    }, [currentLanguage, t])

    useEffect(() => {

        UserService.generateToken();

    }, []);

    const editorRef = useRef(null);
    const [inActivityEmail, setInActivityEmail] = useState("");
    const [courseCompletionEmail, setCourseCompletionEmail] = useState("");
    const [feePaymentEmail, setFeePaymentEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [inActivityEmailSub, setInActivityEmailSub] = useState();
    const [courseCompletionEmailSub, setCourseCompletionEmailSub] = useState();
    const [feePaymentEmailSub, setFeePaymentEmailSub] = useState();

    const [loading, setLoading] = useState(false);

    const [inactiveEmailReminderActive, setInactiveEmailReminderActive] = useState(false);
    const [inactivityDuartion, setInactivityDuartion] = useState(0);
    const [emailSentInterval, setEmailSentInterval] = useState(0);
    const [allAdminMasterConfigurations, setAllAdminMasterConfigurations] = useState([]);
    const [allAdminConfigurations, setAllAdminConfigurations] = useState([]);
    const [getSelectedConfigName, setSelectedConfigName] = useState();
    const [reminder1MDuartion, setReminder1MDuartion] = useState(0);
    const [reminder2MDuartion, setReminder2MDuartion] = useState(0);
    const [reminder3MDuartion, setReminder3MDuartion] = useState(0);
    const [fee1stReminder, setFee1stReminder] = useState(0);
    const [fee2ndReminder, setFee2ndReminder] = useState(0);
    const [fee3rdReminder, setfee3rdReminder] = useState(0);



    useEffect(() => {
        getAllAdminMasterConfigurations();
        getAllAdminConfigurations();
    }, [])

    const setEmailData = (masterData) => {
        masterData.forEach((e) => {
            switch (e?.adminSettingReminderName) {
                case "inactivity_reminder":
                    setInActivityEmail(e?.emailTemplate);
                    setInActivityEmailSub(e?.emailSubject);
                    break;

                case "course_completion_reminder":
                    setCourseCompletionEmail(e?.emailTemplate);
                    setCourseCompletionEmailSub(e?.emailSubject);
                    break;

                case "fee_payment_reminder":
                    setFeePaymentEmail(e?.emailTemplate);
                    setFeePaymentEmailSub(e?.emailSubject);
                    break;

                default:
                    break;
            }
        });
    };

    const getAllAdminMasterConfigurations = () => {
        setLoading(true);
        try {
            adminServices.getAllAdminMasterConfigurations()
                .then((res) => {

                    setAllAdminMasterConfigurations(res.data);
                    setEmailData(res.data);

                    setLoading(false);
                }).catch((err) => {

                    setLoading(false);
                    swal(`${t('error')}`, `${t('something_wrong_try_again')}`, "error")
                })
        } catch (err) {

            setLoading(false);
            swal(`${t('error')}`, `${t('something_wrong_try_again')}`, "error")
        }

    }

    const getAllAdminConfigurations = () => {
        setLoading(true);
        try {
            adminServices.getAllAdminConfigurations()
                .then((res) => {

                    // console.log("getAllAdminConfigurations -> ", res.data);
                    setAllAdminConfigurations(res.data);
                    setInactivityDuartion(res.data[0]?.inactivity_reminder.inactivity_reminder_duration);
                    setEmailSentInterval(res.data[0]?.inactivity_reminder.inactivity_inactivity_days);
                    setReminder1MDuartion(res.data[1]?.course_completion_reminder.cc_reminder_1m_course_duration);
                    setReminder2MDuartion(res.data[1]?.course_completion_reminder.cc_reminder_2m_course_duration);
                    setReminder3MDuartion(res.data[1]?.course_completion_reminder.cc_reminder_3m_course_duration);
                    setFee1stReminder(res.data[2]?.fee_payment_reminder.fee_payment_1st_reminder);
                    setFee2ndReminder(res.data[2]?.fee_payment_reminder.fee_payment_2nd_reminder);
                    setfee3rdReminder(res.data[2]?.fee_payment_reminder.fee_payment_3rd_reminder);
                    setLoading(false);
                }).catch((err) => {

                    setLoading(false);
                    swal(`${t('error')}`, `${t('something_wrong_try_again')}`, "error")
                })
        } catch (err) {

            setLoading(false);
            swal(`${t('error')}`, `${t('something_wrong_try_again')}`, "error")
        }
    }

    const setInactiveEmailReminder = (flag, remindersConfigKey) => {
        setLoading(true);
        try {
            adminServices.setInactiveEmailReminder(flag, remindersConfigKey)
                .then((res) => {

                    if (res.status == 200) {
                        setLoading(false);
                        swal(`${t('success')}`, "Updated Successfully", "success")
                        getAllAdminConfigurations();
                    }
                })
                .catch((err) => {

                    setLoading(false);
                    if (err.response.status == 400) {
                        swal(`${t('error')}`, "Invalid Value passed", "error")
                    } else {
                        swal(`${t('error')}`, `${t('something_wrong_try_again')}`, "error")
                    }
                    getAllAdminConfigurations();
                })
        } catch (err) {

            setLoading(false);
            swal(`${t('error')}`, `${t('something_wrong_try_again')}`, "error")
            getAllAdminConfigurations();
        }
    }

    const handleConfigDuartionSubmit = (days, configKey) => {
        setLoading(true);
        try {
            adminServices.setConfigDurationDays(days, configKey)
                .then((res) => {

                    if (res.status == 200) {
                        setLoading(false);
                        swal(`${t('success')}`, "Updated Successfully", "success")
                        getAllAdminConfigurations();
                    }
                })
                .catch((err) => {

                    setLoading(false);
                    if (err.response.status == 400) {
                        swal(`${t('error')}`, "Invalid Value passed", "error")
                    } else {
                        swal(`${t('error')}`, `${t('something_wrong_try_again')}`, "error")
                    }
                    getAllAdminConfigurations();
                })
        } catch (err) {

            setLoading(false);
            swal(`${t('error')}`, `${t('something_wrong_try_again')}`, "error")
            getAllAdminConfigurations();
        }
    }

    const handleInactiveEmailReminderAlert = (remindersConfigKey) => {
        setInactiveEmailReminderActive(!inactiveEmailReminderActive);
        if (!inactiveEmailReminderActive) {
            setInactiveEmailReminder(1, remindersConfigKey);
        } else {
            setInactiveEmailReminder(0, remindersConfigKey);
        }
    };

    const handleConfigDurationChange = (event, config) => {

        if (config == "inactivity_reminder_duration")
            setInactivityDuartion(event.target.value);
        if (config == "cc_reminder_1m_course_duration")
            setReminder1MDuartion(event.target.value);
        if (config == "cc_reminder_2m_course_duration")
            setReminder2MDuartion(event.target.value);
        if (config == "cc_reminder_3m_course_duration")
            setReminder3MDuartion(event.target.value);
        if (config == "fee_payment_1st_reminder")
            setFee1stReminder(event.target.value);
        if (config == "fee_payment_2nd_reminder")
            setFee2ndReminder(event.target.value);
        if (config == "fee_payment_3rd_reminder")
            setfee3rdReminder(event.target.value);

    };

    const handleEmailSentIntervalChange = (event) => {
        setEmailSentInterval(event.target.value);
    };

    const masterSettingOption = allAdminMasterConfigurations?.map((config) => {
        return {
            value: config.adminSettingReminderName,
            label: config.description,
        };
    });

    const validateEditorContent = (html) => {
        const text = html.replace(/<[^>]*>/g, "").trim();
        const regex = /^[A-Za-z0-9&, .\d:+=\-/"'(){}\n\u0020\u00A0●○■→]*$/;

        if (!text) {
            return "Email template cannot be empty";
        }
        if (text.length < 10) {
            return "Content must be at least 10 characters";
        }
        if (text.length > 5000) {
            return "Content must be less than 5000 characters";
        }
        if (!regex.test(text)) {
            return "Alphabet digit space and special character(. , &  () \" ' - = :  {}) are Allowed";
        }
        return "";
    };


    const onBlurInActivityEmailHandler = (inActivityEmail) => {
        const error = validateEditorContent(inActivityEmail);
        setEmailError(error);
    }

    const updateEMailConfigrations = (emailConfig) => {

        adminServices.updateeMailConfigrations(emailConfig)
            .then(res => {

                switch (res?.adminSettingReminderName) {
                    case "inactivity_reminder":
                        setInActivityEmail(res?.emailTemplate);
                        setInActivityEmailSub(res?.emailSubject);
                        break;

                    case "course_completion_reminder":
                        setCourseCompletionEmail(res?.emailTemplate);
                        setCourseCompletionEmailSub(res?.emailSubject);
                        break;

                    case "fee_payment_reminder":
                        setFeePaymentEmail(res?.emailTemplate);
                        setFeePaymentEmailSub(res?.emailSubject);
                        break;

                    default:
                        break;
                }

            }).catch(err => {
                //console.log(err);
            })

    }

    const handleIntervalEmailSubmit = () => {
        const error = validateEditorContent(inActivityEmail);

        if (error) {
            setEmailError(error);
            return;
        }

        // console.log("Submitting email template:", inActivityEmail);

        let emailConfig = {
            adminSettingReminderName: "inactivity_reminder",
            description: "",
            emailSubject: inActivityEmailSub,
            emailTemplate: inActivityEmail
        }

        updateEMailConfigrations(emailConfig);

    };

    const onBlurCourseCompletionEmailHandler = (courseCompletionEmail) => {
        const error = validateEditorContent(courseCompletionEmail);
        setEmailError(error);
    }

    const handleCourseCompletionEmailSubmit = () => {
        const error = validateEditorContent(courseCompletionEmail);

        if (error) {
            setEmailError(error);
            return;
        }

        // console.log("Submitting email template:", courseCompletionEmail);

        let emailConfig = {
            adminSettingReminderName: "course_completion_reminder",
            description: "",
            emailSubject: courseCompletionEmailSub,
            emailTemplate: courseCompletionEmail
        }

        updateEMailConfigrations(emailConfig);
    };

    const onBlurFeePaymentEmailHandler = (feePaymentEmail) => {
        const error = validateEditorContent(feePaymentEmail);
        setEmailError(error);
    }

    const handleFeePaymentEmailSubmit = () => {
        const error = validateEditorContent(feePaymentEmail);

        if (error) {
            setEmailError(error);
            return;
        }

        // console.log("Submitting email template:", feePaymentEmail);

        let emailConfig = {
            adminSettingReminderName: "fee_payment_reminder",
            description: "",
            emailSubject: feePaymentEmailSub,
            emailTemplate: feePaymentEmail
        }

        updateEMailConfigrations(emailConfig);
    };


    return (
        <div className="container-scroller">
            <Navbar />
            {/* <StickyMenu /> */}
            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                {loading && (
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(255, 255, 255, 0.7)', // Adjust the transparency as needed
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 1000, // Ensure it's above other elements
                        }}
                    >
                        {/* Loader */}
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Circles height={40} width={40} color="#4fa94d" ariaLabel="circles-loading" />
                        </div>
                    </div>
                )}
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div>
                            <div className="page-header">
                                <h3 className="page-title">
                                    Configuration Setting
                                </h3>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="!#" onClick={event => event.preventDefault()}>Configuration Setting</a></li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        <div className="col-lg-12 grid-margin stretch-card">
                            <div className="card" style={{ padding: "40px" }}>
                                <div className="border bg-light p-3 mt-2" style={{ margin: "10px" }}>
                                    <Row >
                                        <Col lg="12">
                                            <div>
                                                <h4 style={{ textAlign: 'center', fontWeight: 'bold', position: "relative" }}>
                                                    <span className='text-success'>Configuration </span>
                                                    <span className='text-secondary'>Setting</span>
                                                    <span style={{ position: 'absolute', left: "48%", bottom: "-3px", width: '6%', height: '2px', backgroundColor: '#28a745' }}></span>
                                                </h4>
                                            </div>
                                        </Col>
                                    </Row>
                                    <p>Select Configuration</p>
                                    <ReactSelect options={masterSettingOption} isMulti={false} onChange={(selectedOption) => {
                                        // console.log(selectedOption)
                                        if (selectedOption) {
                                            const selectedValue = selectedOption.value;
                                            // console.log("Selected value:", selectedValue);
                                            setSelectedConfigName(selectedValue);
                                        }
                                    }} />

                                </div>

                                <Row>
                                    {/* BOX-1 TO TOGGLE THE Email Reminders for Inactive Users */}
                                    {/* <Col lg={12} md={12} sm={12} className="grid-margin stretch-card"> */}
                                    {allAdminConfigurations.map((adminC, index) => {
                                        // console.log(adminC);
                                        // console.log(index);
                                        return (
                                            <>
                                                {(getSelectedConfigName == "inactivity_reminder") && (index == 0) && <><Col lg={4}><div className="card" style={{ margin: "10px" }}>
                                                    <div className="config">
                                                        <div className="config-body" style={{ backgroundColor: '#f5f5f5', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                                                            <label className="form-check-label" style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                                                                <span style={{ marginRight: '10px' }}>Activate Email Reminders for Inactive Users</span>
                                                                <Switch
                                                                    onChange={() => handleInactiveEmailReminderAlert("inactivity_reminder_enabled")}
                                                                    checked={adminC.inactivity_reminder?.inactivity_reminder_enabled == 1}
                                                                    className="react-switch"
                                                                />
                                                            </label>
                                                            <div style={{ marginTop: '15px', display: 'flex', alignItems: 'center' }}>
                                                                <Form.Group style={{ marginRight: '10px', flex: 1 }}>
                                                                    <Form.Label>Number of Days of inactivity</Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={inactivityDuartion}
                                                                        onChange={(e) => handleConfigDurationChange(e, "inactivity_reminder_duration")}
                                                                    />
                                                                </Form.Group>
                                                                <div style={{ marginTop: "20px" }}>
                                                                    <Button
                                                                        variant="primary"
                                                                        onClick={() => handleConfigDuartionSubmit(inactivityDuartion, "inactivity_reminder_duration")}
                                                                        style={{ marginTop: '10px', marginLeft: '10px' }}
                                                                        size="sm"
                                                                    >
                                                                        Submit
                                                                    </Button>
                                                                    <OverlayTrigger
                                                                        overlay={
                                                                            <Tooltip id="tooltip-disabled">
                                                                                The number of days of inactivity of a user!
                                                                            </Tooltip>
                                                                        }
                                                                        placement="top"
                                                                    >
                                                                        <a className="hover-fx1" style={{ marginTop: '10px', marginLeft: '10px' }}>
                                                                            <i className="fa fa-info-circle fa-lg" style={{ color: '#000' }}></i>
                                                                        </a>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                            <div style={{ marginTop: '15px', display: 'flex', alignItems: 'center' }}>
                                                                <Form.Group style={{ marginRight: '10px', flex: 1 }}>
                                                                    <Form.Label>Interval in Days to sent Email</Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={emailSentInterval}
                                                                        onChange={handleEmailSentIntervalChange}
                                                                    />
                                                                </Form.Group>
                                                                <div style={{ marginTop: "20px" }}>
                                                                    <Button
                                                                        variant="primary"
                                                                        onClick={() => handleConfigDuartionSubmit(emailSentInterval, "inactivity_inactivity_days")}
                                                                        style={{ marginTop: '1ppx', marginLeft: '10px' }}
                                                                        size="sm"
                                                                    >
                                                                        Submit
                                                                    </Button>
                                                                    <OverlayTrigger
                                                                        overlay={
                                                                            <Tooltip id="tooltip-disabled">
                                                                                Interval in days after which the email will be sent to the users regarding the inactivity.
                                                                            </Tooltip>
                                                                        }
                                                                        placement="top"
                                                                    >
                                                                        <a className="hover-fx1" style={{ marginTop: '10px', marginLeft: '10px' }}>
                                                                            <i className="fa fa-info-circle fa-lg" style={{ color: '#000' }}></i>
                                                                        </a>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </Col>
                                                    <Col lg={8}>
                                                        <div className="card" style={{ margin: "20px" }}>
                                                            <label htmlFor="name">
                                                                Email Template <span className="text-danger">*</span>
                                                                <span
                                                                    title="Do not remove the links or text inside curly { } brackets"
                                                                    style={{ marginLeft: "6px", cursor: "help", color: "#dc3545" }}
                                                                >
                                                                    <i className="fa fa-info-circle fa-lg" style={{ color: '#a50000ff' }}></i>
                                                                </span>
                                                            </label>
                                                            <label style={{textAlign:"end", fontSize:"12px"}}>{'{'}0{'}'} - User Name, {'{'}1{'}'} - Inactive Days, {'{'}2{'}'} - Last login date</label>
                                                            <Editor
                                                                tinymceScriptSrc={process.env.PUBLIC_URL +
                                                                    '/tinymce/tinymce.min.js'}
                                                                onInit={(evt, editor) => { editorRef.current = editor }}
                                                                value={inActivityEmail}
                                                                onEditorChange={(content) => {
                                                                    setInActivityEmail(content);
                                                                    setEmailError(""); // clear error while typing
                                                                }}
                                                                init={{
                                                                    height: 400,
                                                                    menubar: false,
                                                                    plugins: [
                                                                        'advlist', 'autolink', 'lists', 'link', 'image',
                                                                        'charmap',
                                                                        'anchor', 'searchreplace', 'visualblocks', 'code',
                                                                        'fullscreen',
                                                                        'insertdatetime', 'media', 'table', 'preview',
                                                                        'help', 'wordcount'
                                                                    ],
                                                                    toolbar: 'undo redo | blocks | ' +
                                                                        'bold italic forecolor | alignleft aligncenter ' +
                                                                        'alignright alignjustify | bullist numlist outdentindent | ' +
                                                                        'removeformat | help',
                                                                    content_style: 'body {font - family:Helvetica,Arial,sansserif;font-size:14px }',

                                                                }}
                                                                onError={(err) => {
                                                                    console.error("TinyMCE Error:", err);
                                                                    setEmailError("Editor failed to load. Please refresh.");
                                                                }}
                                                                onBlur={() => { onBlurInActivityEmailHandler(inActivityEmail) }}
                                                            />
                                                            {emailError && (
                                                                <span className="email_input-msg" style={{ color: "#dc3545" }}>
                                                                    {emailError}
                                                                </span>
                                                            )}

                                                            <div className='template-button'>
                                                                <Button
                                                                    variant="primary"
                                                                    onClick={() => handleIntervalEmailSubmit()}
                                                                    size="sm"
                                                                >
                                                                    Submit Template
                                                                </Button>
                                                            </div>
                                                        </div>

                                                    </Col>

                                                </>}
                                                {(getSelectedConfigName == "course_completion_reminder") && (index == 1) && <><Col lg={4}><div className="card" style={{ margin: "10px" }}>
                                                    <div className="config">
                                                        <div className="config-body" style={{ backgroundColor: '#f5f5f5', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                                                            <label className="form-check-label" style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                                                                <span style={{ marginRight: '10px' }}>Activate Course Completion Email Reminders for Users</span>
                                                                <Switch
                                                                    onChange={() => handleInactiveEmailReminderAlert("course_completion_reminder_enabled")}
                                                                    checked={adminC.course_completion_reminder?.course_completion_reminder_enabled == 1}
                                                                    className="react-switch"
                                                                />
                                                            </label>
                                                            <div style={{ marginTop: '15px', display: 'flex', alignItems: 'center' }}>
                                                                <Form.Group style={{ marginRight: '10px', flex: 1 }}>
                                                                    <Form.Label>Interval in Days to sent Email for 1 month Course</Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={reminder1MDuartion}
                                                                        onChange={(e) => handleConfigDurationChange(e, "cc_reminder_1m_course_duration")}
                                                                    />
                                                                </Form.Group>
                                                                <div style={{ marginTop: "20px" }}>
                                                                    <Button
                                                                        variant="primary"
                                                                        onClick={() => handleConfigDuartionSubmit(reminder1MDuartion, "cc_reminder_1m_course_duration")}
                                                                        style={{ marginTop: '10px', marginLeft: '10px' }}
                                                                        size="sm"
                                                                    >
                                                                        Submit
                                                                    </Button>
                                                                    <OverlayTrigger
                                                                        overlay={
                                                                            <Tooltip id="tooltip-disabled">
                                                                                Reminder dutation for user for 1 month course.
                                                                            </Tooltip>
                                                                        }
                                                                        placement="top"
                                                                    >
                                                                        <a className="hover-fx1" style={{ marginTop: '10px', marginLeft: '10px' }}>
                                                                            <i className="fa fa-info-circle fa-lg" style={{ color: '#000' }}></i>
                                                                        </a>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                            <div style={{ marginTop: '15px', display: 'flex', alignItems: 'center' }}>
                                                                <Form.Group style={{ marginRight: '10px', flex: 1 }}>
                                                                    <Form.Label>Interval in Days to sent Email for 2 month Course</Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={reminder2MDuartion}
                                                                        onChange={(e) => handleConfigDurationChange(e, "cc_reminder_2m_course_duration")}
                                                                    />
                                                                </Form.Group>
                                                                <div style={{ marginTop: "20px" }}>
                                                                    <Button
                                                                        variant="primary"
                                                                        onClick={() => handleConfigDuartionSubmit(reminder2MDuartion, "cc_reminder_2m_course_duration")}
                                                                        style={{ marginTop: '10px', marginLeft: '10px' }}
                                                                        size="sm"
                                                                    >
                                                                        Submit
                                                                    </Button>
                                                                    <OverlayTrigger
                                                                        overlay={
                                                                            <Tooltip id="tooltip-disabled">
                                                                                Reminder dutation for user for 2 month course.
                                                                            </Tooltip>
                                                                        }
                                                                        placement="top"
                                                                    >
                                                                        <a className="hover-fx1" style={{ marginTop: '10px', marginLeft: '10px' }}>
                                                                            <i className="fa fa-info-circle fa-lg" style={{ color: '#000' }}></i>
                                                                        </a>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                            <div style={{ marginTop: '15px', display: 'flex', alignItems: 'center' }}>
                                                                <Form.Group style={{ marginRight: '10px', flex: 1 }}>
                                                                    <Form.Label>Interval in Days to sent Email for 3 month Course</Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={reminder3MDuartion}
                                                                        onChange={(e) => handleConfigDurationChange(e, "cc_reminder_3m_course_duration")}
                                                                    />
                                                                </Form.Group>
                                                                <div style={{ marginTop: "20px" }}>
                                                                    <Button
                                                                        variant="primary"
                                                                        onClick={() => handleConfigDuartionSubmit(reminder3MDuartion, "cc_reminder_3m_course_duration")}
                                                                        style={{ marginTop: '10px', marginLeft: '10px' }}
                                                                        size="sm"
                                                                    >
                                                                        Submit
                                                                    </Button>
                                                                    <OverlayTrigger
                                                                        overlay={
                                                                            <Tooltip id="tooltip-disabled">
                                                                                Reminder dutation for user for 3 month course.
                                                                            </Tooltip>
                                                                        }
                                                                        placement="top"
                                                                    >
                                                                        <a className="hover-fx1" style={{ marginTop: '10px', marginLeft: '10px' }}>
                                                                            <i className="fa fa-info-circle fa-lg" style={{ color: '#000' }}></i>
                                                                        </a>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </Col>
                                                    <Col lg={8}>
                                                        <div className="card" style={{ margin: "10px" }}>
                                                            <label htmlFor="name">
                                                                Email Template <span className="text-danger">*</span>
                                                                <span
                                                                    title="Do not remove the links or text inside curly { } brackets"
                                                                    style={{ marginLeft: "6px", cursor: "help", color: "#dc3545" }}
                                                                >
                                                                    <i className="fa fa-info-circle fa-lg" style={{ color: '#a50000ff' }}></i>
                                                                </span>
                                                            </label>
                                                            <label style={{textAlign:"end", fontSize:"12px"}}>{'{'}0{'}'} - User Name, {'{'}1{'}'} - Course Name, {'{'}2{'}'} - Days Completed, {'{'}3{'}'} - Course Last Date</label>
                                                            <Editor
                                                                tinymceScriptSrc={process.env.PUBLIC_URL +
                                                                    '/tinymce/tinymce.min.js'}
                                                                onInit={(evt, editor) => { editorRef.current = editor }}
                                                                value={courseCompletionEmail}
                                                                onEditorChange={(content) => {
                                                                    setCourseCompletionEmail(content);
                                                                    setEmailError(""); // clear error while typing
                                                                }}
                                                                init={{
                                                                    height: 400,
                                                                    menubar: false,
                                                                    plugins: [
                                                                        'advlist', 'autolink', 'lists', 'link', 'image',
                                                                        'charmap',
                                                                        'anchor', 'searchreplace', 'visualblocks', 'code',
                                                                        'fullscreen',
                                                                        'insertdatetime', 'media', 'table', 'preview',
                                                                        'help', 'wordcount'
                                                                    ],
                                                                    toolbar: 'undo redo | blocks | ' +
                                                                        'bold italic forecolor | alignleft aligncenter ' +
                                                                        'alignright alignjustify | bullist numlist outdentindent | ' +
                                                                        'removeformat | help',
                                                                    content_style: 'body {font - family:Helvetica,Arial,sansserif;font-size:14px }',

                                                                }}
                                                                onError={(err) => {
                                                                    console.error("TinyMCE Error:", err);
                                                                    setEmailError("Editor failed to load. Please refresh.");
                                                                }}
                                                                onBlur={() => { onBlurCourseCompletionEmailHandler(courseCompletionEmail) }}
                                                            />
                                                            {emailError && (
                                                                <span className="email_input-msg" style={{ color: "#dc3545" }}>
                                                                    {emailError}
                                                                </span>
                                                            )}

                                                            <div className='template-button'>
                                                                <Button
                                                                    variant="primary"
                                                                    onClick={() => handleCourseCompletionEmailSubmit()}
                                                                    size="sm"
                                                                >
                                                                    Submit Template
                                                                </Button>
                                                            </div>
                                                        </div>

                                                    </Col>
                                                </>}
                                                {(getSelectedConfigName == "fee_payment_reminder") && (index == 2) && <><Col lg={4}><div className="card" style={{ margin: "10px" }}>
                                                    <div className="config">
                                                        <div className="config-body" style={{ backgroundColor: '#f5f5f5', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                                                            <label className="form-check-label" style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                                                                <span style={{ marginRight: '10px' }}>Activate reminder for payment approve users</span>
                                                                <Switch
                                                                    onChange={() => handleInactiveEmailReminderAlert("fee_payment_reminder_enables")}
                                                                    checked={adminC.fee_payment_reminder?.fee_payment_reminder_enables == 1}
                                                                    className="react-switch"
                                                                />
                                                            </label>
                                                            <div style={{ marginTop: '15px', display: 'flex', alignItems: 'center' }}>
                                                                <Form.Group style={{ marginRight: '10px', flex: 1 }}>
                                                                    <Form.Label>1st Reminder to pay fees after approved(days)</Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={fee1stReminder}
                                                                        onChange={(e) => handleConfigDurationChange(e, "fee_payment_1st_reminder")}
                                                                    />
                                                                </Form.Group>
                                                                <div style={{ marginTop: "20px" }}>
                                                                    <Button
                                                                        variant="primary"
                                                                        onClick={() => handleConfigDuartionSubmit(fee1stReminder, "fee_payment_1st_reminder")}
                                                                        style={{ marginTop: '10px', marginLeft: '10px' }}
                                                                        size="sm"
                                                                    >
                                                                        Submit
                                                                    </Button>
                                                                    <OverlayTrigger
                                                                        overlay={
                                                                            <Tooltip id="tooltip-disabled">
                                                                                1st Reminder email duration for payment approved users.
                                                                            </Tooltip>
                                                                        }
                                                                        placement="top"
                                                                    >
                                                                        <a className="hover-fx1" style={{ marginTop: '10px', marginLeft: '10px' }}>
                                                                            <i className="fa fa-info-circle fa-lg" style={{ color: '#000' }}></i>
                                                                        </a>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                            <div style={{ marginTop: '15px', display: 'flex', alignItems: 'center' }}>
                                                                <Form.Group style={{ marginRight: '10px', flex: 1 }}>
                                                                    <Form.Label>2nd Reminder to pay fees after approved(days)</Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={fee2ndReminder}
                                                                        onChange={(e) => handleConfigDurationChange(e, "fee_payment_2nd_reminder")}
                                                                    />
                                                                </Form.Group>
                                                                <div style={{ marginTop: "20px" }}>
                                                                    <Button
                                                                        variant="primary"
                                                                        onClick={() => handleConfigDuartionSubmit(fee2ndReminder, "fee_payment_2nd_reminder")}
                                                                        style={{ marginTop: '10px', marginLeft: '10px' }}
                                                                        size="sm"
                                                                    >
                                                                        Submit
                                                                    </Button>
                                                                    <OverlayTrigger
                                                                        overlay={
                                                                            <Tooltip id="tooltip-disabled">
                                                                                2nd Reminder email duration for payment approved users.
                                                                            </Tooltip>
                                                                        }
                                                                        placement="top"
                                                                    >
                                                                        <a className="hover-fx1" style={{ marginTop: '10px', marginLeft: '10px' }}>
                                                                            <i className="fa fa-info-circle fa-lg" style={{ color: '#000' }}></i>
                                                                        </a>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                            <div style={{ marginTop: '15px', display: 'flex', alignItems: 'center' }}>
                                                                <Form.Group style={{ marginRight: '10px', flex: 1 }}>
                                                                    <Form.Label>3rd Reminder to pay fees after approved(days)</Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={fee3rdReminder}
                                                                        onChange={(e) => handleConfigDurationChange(e, "fee_payment_3rd_reminder")}
                                                                    />
                                                                </Form.Group>
                                                                <div style={{ marginTop: "20px" }}>
                                                                    <Button
                                                                        variant="primary"
                                                                        onClick={() => handleConfigDuartionSubmit(fee3rdReminder, "fee_payment_3rd_reminder")}
                                                                        style={{ marginTop: '10px', marginLeft: '10px' }}
                                                                        size="sm"
                                                                    >
                                                                        Submit
                                                                    </Button>
                                                                    <OverlayTrigger
                                                                        overlay={
                                                                            <Tooltip id="tooltip-disabled">
                                                                                3rd Reminder email duration for payment approved users.
                                                                            </Tooltip>
                                                                        }
                                                                        placement="top"
                                                                    >
                                                                        <a className="hover-fx1" style={{ marginTop: '10px', marginLeft: '10px' }}>
                                                                            <i className="fa fa-info-circle fa-lg" style={{ color: '#000' }}></i>
                                                                        </a>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </Col>
                                                    <Col lg={8}>
                                                        <div className="card" style={{ margin: "10px" }}>
                                                            <label htmlFor="name">
                                                                Email Template <span className="text-danger">*</span>
                                                                <span
                                                                    title="Do not remove the links or text inside curly { } brackets"
                                                                    style={{ marginLeft: "6px", cursor: "help", color: "#dc3545" }}
                                                                >
                                                                    <i className="fa fa-info-circle fa-lg" style={{ color: '#a50000ff' }}></i>
                                                                </span>
                                                            </label>
                                                            <label style={{textAlign:"end", fontSize:"12px"}}>{'{'}0{'}'} - User Name, {'{'}1{'}'} - Course Name, {'{'}2{'}'} - Days Count from request date</label>
                                                            <Editor
                                                                tinymceScriptSrc={process.env.PUBLIC_URL +
                                                                    '/tinymce/tinymce.min.js'}
                                                                onInit={(evt, editor) => { editorRef.current = editor }}
                                                                value={feePaymentEmail}
                                                                onEditorChange={(content) => {
                                                                    setFeePaymentEmail(content);
                                                                    setEmailError(""); // clear error while typing
                                                                }}
                                                                init={{
                                                                    height: 400,
                                                                    menubar: false,
                                                                    plugins: [
                                                                        'advlist', 'autolink', 'lists', 'link', 'image',
                                                                        'charmap',
                                                                        'anchor', 'searchreplace', 'visualblocks', 'code',
                                                                        'fullscreen',
                                                                        'insertdatetime', 'media', 'table', 'preview',
                                                                        'help', 'wordcount'
                                                                    ],
                                                                    toolbar: 'undo redo | blocks | ' +
                                                                        'bold italic forecolor | alignleft aligncenter ' +
                                                                        'alignright alignjustify | bullist numlist outdentindent | ' +
                                                                        'removeformat | help',
                                                                    content_style: 'body {font - family:Helvetica,Arial,sansserif;font-size:14px }',

                                                                }}
                                                                onError={(err) => {
                                                                    console.error("TinyMCE Error:", err);
                                                                    setEmailError("Editor failed to load. Please refresh.");
                                                                }}
                                                                onBlur={() => { onBlurFeePaymentEmailHandler(courseCompletionEmail) }}
                                                            />
                                                            {emailError && (
                                                                <span className="email_input-msg" style={{ color: "#dc3545" }}>
                                                                    {emailError}
                                                                </span>
                                                            )}

                                                            <div className='template-button'>
                                                                <Button
                                                                    variant="primary"
                                                                    onClick={() => handleFeePaymentEmailSubmit()}
                                                                    size="sm"
                                                                >
                                                                    Submit Template
                                                                </Button>
                                                            </div>
                                                        </div>

                                                    </Col>
                                                </>}
                                            </>
                                        );
                                    })}
                                    {/* </Col> */}
                                </Row>
                            </div>
                        </div>
                        <SettingsPanel />
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    )
}

export default AdminConfiguration